import { useGlobal } from "../../../contexts/globalContext";
import { Video } from "../../video-element";

export const CurrentMeetingPreview = () => {
  const { SCREEN_STREAM_MAIN_REF, MEETING_STATUSBAR_VIDEO_MAIN_PREVIEW, LAST_FRAME_IMG } = useGlobal();

  return (
    <div className="meeting-status-box-video-preview">
      <Video
        style={{
          objectFit: "cover",
        }}
        width="82"
        height="50.5"
        id="video__small-screen"
        ref={MEETING_STATUSBAR_VIDEO_MAIN_PREVIEW}
        srcObject={SCREEN_STREAM_MAIN_REF.current}
        autoPlay
        muted
      />
      <img ref={LAST_FRAME_IMG} style={{ borderRadius: 8, filter: "blur(.7px)" }} alt="" />
    </div>
  );
};
